// @flow
import * as React from 'react';
import cableAndFiberMessages from 'esm-web-pro/messages/cableAndFiberMessages';
import { FieldWrapper } from 'speed-js-react-web';
import { FormattedMessage, injectIntl, IntlShape } from 'react-intl';
import BaseSelect from 'esm-web-pro/components/forms/fields/BaseSelect';

type Props = {
    freeFibers: {[number]: Object},
    cable: { id: number },
    onChange: Function,
    value: string,

    intl: IntlShape,
};

const FiberSelect = (props: Props) => {
    const {
        freeFibers, cable, value, onChange, intl: { formatMessage },
    } = props;

    const fiberChoices = Object.keys(freeFibers[cable.id]).reduce((choices, f) => {
        choices[f] = `${formatMessage(cableAndFiberMessages.fiberLong)} ${f}`;
        return choices;
    }, {});

    // const fiberKeys = Object.keys(fiberChoices);
    //
    // if (secondFiber === null) {
    //     handleSecondFiberChange(fiberKeys[0]);
    // }

    return (
        <FieldWrapper
            label={(
                <FormattedMessage
                    id="splicefiberfrom-secondfiberselect-title"
                    defaultMessage="Fiber"
                />
            )}
            required
        >
            <BaseSelect
                choices={fiberChoices}
                value={value || null}
                onChange={(choice) => {
                    onChange(choice);
                }}
            />
        </FieldWrapper>
    );
};

export default injectIntl(FiberSelect);
